module.exports = __webpack_public_path__ + "img/bg.9cc18fd0.png";